<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <v-layout align-center justify-center column pb-2>
          <h2 class="heading-3">Register with email</h2>
        </v-layout>

        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>

        <v-layout justify-center column>

          <v-form ref="form" v-model="valid" @submit="signUp">
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="firstName" :rules="firstNameRules" label="First Name *" required ></v-text-field>
              </v-flex>

              <v-flex xs12 pb-0>
                <v-text-field outline v-model="lastName" :rules="lastNameRules" label="Last Name*"  required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="username" :rules="usernameRules" type="email" label="Email Address *" required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <p class="notice">We need your date of birth in order to provide online ticketing functionality.</p>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 sm3>Date of Birth *</v-flex>
              <v-flex xs12 sm3>
                <v-select
                  :items="days"
                  label="DD *"
                  v-model="dobDay"
                  :rules="dobRules"
                  required
                  outline
                ></v-select>
              </v-flex>
              <v-flex xs12 sm3>
                <v-select
                  :items="months"
                  label="MM *"
                  v-model="dobMonth"
                  :rules="dobRules"
                  required
                  outline
                ></v-select>
              </v-flex>
              <v-flex xs12 sm3>
                <v-select
                  :items="years"
                  label="YYYY *"
                  v-model="dobYear"
                  :rules="dobRules"
                  required
                  outline
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row v-if="dobErrorMessage != null">
              <v-flex xs12 pt-0>
                <p class="dob-error">{{ dobErrorMessage }}</p>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline ref="pass" v-model="pass" :rules="passRules" label="Password *" type="password" required ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field outline ref="passConfirm" v-model="passConfirm" :rules="passConfirmRules" label="Confirm Password *"  type="password"  required></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <p class="password-notice">Your Password must be 8-12 characters in length, contain a special character along with a capital letter and a lower case letter.</p>
              </v-flex>
            </v-layout>

           <v-layout row>
              <v-flex xs12>
                <p class="notice">We'd love to keep in touch. Please let us know which communications you'd like to receive. You can update your preferences at any time from your account.</p>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-switch
                  v-model="optInClub"
                  color="#5bb57c"
                >
                  <template v-slot:label>
                    <div>
                      <strong>Stoke City Football Club</strong>
                      <p class="switch-description">The latest news, ticketing, retail updates and behind the scenes content from Stoke City Football Club, Stoke City Foundation, Stoke City Women and special offers we share from our partners.</p>
                    </div>
                  </template>
                </v-switch>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 py-0>
                <v-switch
                  v-model="optInEvents"
                  color="#5bb57c"
                >
                  <template v-slot:label>
                    <div>
                      <strong>Events</strong>
                      <p class="switch-description">Keep up to date with what's on at the bet365 Stadium on non-matchdays (e.g. concerts, dinners, conferences and other entertainment events).</p>
                    </div>
                  </template>
                </v-switch>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <p class="notice">You can access our preference centre at any time to opt-out of communications and control how we use your data.</p>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pt-0 pb-1>
                <v-switch
                  id="termsSwitch"
                  :label="`I have read and understood the Club's privacy policy`"
                  v-model="termsAgree"
                  :rules="termsAgreeRules"
                  color="#5bb57c"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pt-0 pb-3>
                <p><a class="privacy-policy text-button" href="https://www.stokecityfc.com/privacypolicy" target="_blank">https://www.stokecityfc.com/privacypolicy</a></p>
              </v-flex>
            </v-layout>

            <v-layout row align-center mx-1 py-0>
              <router-link to="/" class="text-button">Already registered?</router-link>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid || !dobValid || loading">{{ loading ? 'Registering...' : 'Register' }}</button>
            </v-layout>

          </v-form>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { dayOptions, monthOptions, yearOptions, isValidDob, dobError, formatDob } from '@/utils/dob'

export default {
  name: 'Registration',
  data () {

    return {
      valid: true,
      firstNameRules: [
        v => !!v || 'First name is required'
      ],
      dobRules: [
        v => !!v || 'Date of Birth is required'
      ],
      lastNameRules: [
        v => !!v || 'Last name is required'
      ],
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        v => /.*[a-z].*/.test(v) || 'Password must contain at least one lower case letter',
        v => /.*[A-Z].*/.test(v) || 'Password must contain at least one upper case letter',
        v => /\d/.test(v) || 'Password must contain at least one number',
        v => /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) || 'Password must contain at least one special character (e.g. ^ $ * . ! @ # % &)',
        v => (this.passConfirm.length >=8 && v == this.passConfirm) || 'Password confirmation must match password'
      ],
      passConfirmRules: [
        v => (v == this.pass) || 'Password confirmation must match password'
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid'
      ],
      termsAgreeRules: [
        v => !!v || 'You must agree to continue'
      ],
      firstName: '',
      lastName: '',
      username: '',
      pass: '',
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      days: dayOptions(),
      months: monthOptions(),
      years: yearOptions(),
      optInClub: true,
      optInEvents: true,
      termsAgree: false,
      passConfirm: '',
      error: null,
      loading: false
    }
  },
  computed: {
    dobValid () {
      return isValidDob(this.dobDay, this.dobMonth, this.dobYear)
    },
    dobErrorMessage () {
      return dobError(this.dobDay, this.dobMonth, this.dobYear)
    }
  },
  watch: {
    pass: function (val, oldVal) {
      this.$refs.form.validate()
    },
    passConfirm: function (val, oldVal) {
      this.$refs.form.validate()
    }
  },
  methods: {
    signUp (e) {
        e.preventDefault()
        // a sign up is already in flight - set synchronously so that repeated
        // clicks are blocked before Vue has re-rendered the disabled button
        if (this.loading) {
          return
        }
        // guard against submission by keyboard, which bypasses the disabled button
        if (!this.$refs.form.validate() || !this.dobValid) {
          return
        }
        this.loading = true
        var email = this.username
        var password = this.pass
        var firstName = this.firstName
        var lastName = this.lastName
        var optInClub = this.optInClub.toString();
        var optInEvents = this.optInEvents.toString();
        var termsAgree = this.termsAgree.toString();

        var attributesList = {
            "given_name": firstName,
            "family_name": lastName,
            "custom:club_email": optInClub,
            "custom:club_sms": optInClub,
            "custom:womens_email": optInClub,
            "custom:womens_sms": optInClub,
            "custom:foundation_email": optInClub,
            "custom:foundation_sms": optInClub,
            "custom:partner_email": optInClub,
            "custom:partner_sms": optInClub,
            "custom:events_email": optInEvents,
            "custom:events_sms": optInEvents,
            "custom:privacy_accepted": termsAgree,
            "birthdate": formatDob(this.dobDay, this.dobMonth, this.dobYear)
        }

        this.$signUp(email, password, attributesList).subscribe((data) => {
            console.log("sign up successful"+data)
            this.$router.push("/confirm");
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err.message)
            this.error = err
            // let them correct the problem and try again
            this.loading = false
        });

    }
  }
}
</script>

<style>
  .password-notice {
    margin: 0 0 20px;
    padding: 0 0 40px;
    color: #878787;
    font-size: 15px;
    line-height: 22px;
    border-bottom: 1px solid #eee;
  }

  
  .v-input--switch__track.theme--light.error--text {
    color: rgba(0,0,0,0.38) !important;
  }
  .v-input--selection-controls__ripple.error--text{
    color: #fff !important;
  }
  .v-input--switch__thumb.theme--light.error--text{
    color:#fafafa !important;
  }
  .switch-description {
    margin: 4px 0 0;
    font-size: 13px;
    line-height: 18px;
    color: #666;
  }
  .dob-error {
    margin: 0;
    color: #ff5252;
    font-size: 13px;
    line-height: 18px;
  }
</style>